import { useReadStaking2aContract } from './useReadStaking2aContract'
import { usePepperContractAddress } from '../pepper-contract/usePepperContract'

/*
 * Fetches the total staked amount of PEPPER
 * @returns The total staked amount of PEPPER
 */

export function useStaking2aTotalPepperStaked() {
	const pepperAddress = usePepperContractAddress()

	return useReadStaking2aContract({
		functionName: 'getTotalStake',
		args: [pepperAddress],
		query: {
			refetchInterval: 3_000
		}
	})
}
